import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .tableWapper': {
        width: '100%',
        height: '600px',
        overflowX: 'auto',
        '& .tableHead': {
            paddingLeft: '40px',
            height: '60px',
            color: '#9B9B9B',
            backgroundColor: '#FAFAFA',
            borderBottom: '1px solid #D8D8D8',
        },
        '& .iconExpand': {
            margin: '0 10px',
            transform: "rotate(0deg)",
            color: '#9B9B9B',
        },
        '& .iconClose': {
            margin: '0 10px',
            transform: "rotate(-90deg)",
            color: '#9B9B9B',
        },
        '& .extend': {
            backgroundColor: '#fff',
        },
        '& .expandBtn': {
            cursor: 'pointer',
            height: '60px',
            color: '#005F9B',
            fontWeight: 'bold',
            backgroundColor: '#fff',
            borderBottom: '1px solid #D8D8D8',
        },
        '& .closeBtn': {
            cursor: 'pointer',
            height: '60px',
            backgroundColor: '#fff',
            borderBottom: '1px solid #D8D8D8',
        },
        '& .table': {
            minWidth: '650px',
        },
        '& .w290': {
            width: '290px',
        },
        '& .noTeams': {
            height: '60px',
            color: '#9B9B9B',
            borderBottom: '1px solid #D8D8D8',
        },
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
});